export const EXCEL_COURSE_UUID = 'e2eb94cd-271a-42ff-92dc-f77adbe53e9f';
export const EXCEL_TEST_HREF =
  'https://hardskills.lerna.ru/skilltest/excelpro?company=dc66b1de-ac3f-41eb-9014-208999c3d6a7&ask_improve=true';
